import { Button, Space, Table, Input, message } from 'antd';
import React, { useState, useEffect } from 'react';
import FundraiserService from '../../../../Services/services/FundraiserService';
import { useNavigate } from 'react-router-dom';

const { Search } = Input;

const Fundraisers = ({ campaignId }) => {
  const [filteredInfo, setFilteredInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState({});
  const [data, setData] = useState([]);
  const [sortTitle, setSortTitle] = useState(null);
  const [sortValue, setSortValue] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const fetchFundraisers = async (page = 1, pageSize = 10) => {
    setLoading(true);
    try {
      const result = await FundraiserService.getFundraisersByCampaign(
        campaignId, 
        searchTerm, 
        sortTitle, 
        sortValue, 
        page, 
        pageSize
      );
      const formattedData = result.docs.map((doc) => ({
        key: doc._id,
        name: doc.name,
        goal: doc.goal,
        raised: doc.statistics.raised,
        status: doc.status,
        cause: doc.cause.name,
      }));
      setData(formattedData);
      setPagination({
        ...pagination,
        current: page,
        pageSize,
        total: result.totalDocs,
      });
    } catch (error) {
      message.error(error.response.data.error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFundraisers(pagination.current, pagination.pageSize);
  }, [sortTitle, sortValue, searchTerm, pagination.current, pagination.pageSize]);

  const handleChange = (pagination, filters, sorter) => {
    setFilteredInfo(filters);
    setSortedInfo(sorter);
    setPagination({ ...pagination, current: pagination.current });
  };

  const handleSearch = (value) => {
    setSearchTerm(value);
    setPagination({ ...pagination, current: 1 });
  };

  const handleSort = (title) => {
    const newSortValue = sortTitle === title && sortValue === 1 ? -1 : 1;
    setSortTitle(title);
    setSortValue(newSortValue);
  };

  const handleEdit = (fundraiserId) => {
    navigate(`/dashboard/fundraisers/edit/${fundraiserId}`);
  };

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      sorter: true,
      sortOrder: sortedInfo.columnKey === 'name' && sortedInfo.order,
    },
    {
      title: 'Goal',
      dataIndex: 'goal',
      key: 'goal',
      sorter: true,
      sortOrder: sortedInfo.columnKey === 'goal' && sortedInfo.order,
      render: (goal) => `${goal.toLocaleString()}`,
    },
    {
      title: 'Raised',
      dataIndex: 'raised',
      key: 'raised',
      sorter: true,
      sortOrder: sortedInfo.columnKey === 'raised' && sortedInfo.order,
      render: (raised) => `${raised.toLocaleString()}`,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
    },
    {
      title: 'Cause',
      dataIndex: 'cause',
      key: 'cause',
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <Button type="link" onClick={() => handleEdit(record.key)}>
          Edit
        </Button>
      ),
    },
  ];

  return (
    <div className="min-h-[60vh]">
      <Space style={{ marginBottom: 16 }}>
        <span className="text-gray-600">Sort</span>
        <button
          className="bg-green-100 px-3 w-28 rounded-l-lg h-7 border-r ml-4 text-sm"
          onClick={() => handleSort('name')}
        >
          Name: {sortTitle === 'name' ? (sortValue === 1 ? 'A-Z' : 'Z-A') : 'A-Z'}
        </button>
        <button
          className="bg-green-100 px-5 w-28 rounded-r-lg h-7 -ml-2 text-sm"
          onClick={() => handleSort('date')}
        >
          Date: {sortTitle === 'date' ? (sortValue === 1 ? 'A-Z' : 'Z-A') : 'A-Z'}
        </button>
        <Search
          placeholder="Search Campaigns"
          onSearch={handleSearch}
          style={{ width: 200 }}
          className="ml-[20vw]"
        />
        <Button>Add Offline Donations</Button>
      </Space>
      <Table
        columns={columns}
        dataSource={data}
        onChange={handleChange}
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: pagination.total,
          onChange: (page, pageSize) => {
            setPagination({ current: page, pageSize });
          },
        }}
        loading={loading}
      />
    </div>
  );
};

export default Fundraisers;
